import React, { FC, useEffect, useState } from 'react';
import OvBottomActionDrawer from './OvBottomActionDrawer';
import OvSurvey from '../organisms/OvSurvey';
import { Role } from '../../../common/model/type/role.enum';
import { SurveyService } from '../../../services/survey-service';
import { PlatformTypeEnum } from '../../../common/model/type/platform-type.enum';
import { SurveyInstance } from '../../../common/model/dto/survey/survey-instance';

export interface OvProminentActionsProps {
  selectedRole: Role;
  userId: string;
}

const OvProminentActions: FC<OvProminentActionsProps> = ({
  selectedRole,
  userId,
}) => {
  const [isOpenBottomActionDrawer, setIsOpenBottomActionDrawer] =
    useState<boolean>(false);
  const [npsSurvey, setNpsSurvey] = useState<SurveyInstance>();

  useEffect(() => {
    if (selectedRole === Role.Regular) {
      if (!SurveyService.isNpsSurveySnoozed(userId)) {
        SurveyService.getActiveNpsSurvey(
          PlatformTypeEnum.CLINIC_DASHBOARD
        ).then((surveyInstance) => {
          if (surveyInstance?.survey) {
            setNpsSurvey(surveyInstance);
            setIsOpenBottomActionDrawer(true);
          }
        });
      }
    } else if (selectedRole === Role.Admin && isOpenBottomActionDrawer) {
      setIsOpenBottomActionDrawer(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRole]);

  return (
    <OvBottomActionDrawer isOpen={isOpenBottomActionDrawer}>
      {npsSurvey && (
        <OvSurvey
          survey={npsSurvey.survey}
          userId={userId}
          instance_id={npsSurvey.id}
          onClose={() => setIsOpenBottomActionDrawer(false)}
        />
      )}
    </OvBottomActionDrawer>
  );
};

export default OvProminentActions;
